import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enLocale from './en'
import esLocale from './es'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale
  },
  es: {
    ...esLocale
  }
}

export const getLocale = () => {
  return 'es'
}

const i18n = new VueI18n({
  locale: getLocale(),
  messages
})

export default i18n
